import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { SORT_DIRECTION } from '../../../util/CrosstabUtils';
import { updateCrosstabSort } from '../../../actions/crosstabActions';
// import chevronDown from '../../../images/down_arrow_white.png';

const GridSort = props => {
  const { cellElements, cellIndex, updateCrosstabSort,
    direction, variable, ctIndex } = props;
  const [localvariable, setLocalVariable] = useState('');


  const sortDirectionText = (direction === SORT_DIRECTION.DESC)
    ? <span>Sort Descending</span>
    : <span>Sort Ascending</span>;

  const handleMenuClick = cellKey => {
    updateCrosstabSort(direction, cellKey, cellIndex);
    setLocalVariable(cellKey);
    props.handleSortingOfGrid();
  };

  const handleArrowClick = d => {
    updateCrosstabSort(d, variable, ctIndex);
  };

  useEffect(() => {
    if (localvariable && localvariable.length !== 0) {
      if (localvariable === 'none') {
        props.onSort(SORT_DIRECTION.NONE);
      } else {
        props.onSort(direction, localvariable, cellIndex);
      }
    }
    // return () => {
    //   updateCrosstabSort(direction, '', cellIndex);
    // };
  }, [localvariable]);

  const renderUpDownButtons = () => {
    return (
      <span className="crosstab-view-sort-container">
        <button
          className="crosstab-viw-sort-asc-btn"
          onClick={() => handleArrowClick(SORT_DIRECTION.ASC)}
          disabled={direction === SORT_DIRECTION.ASC}
        >
          <FontAwesome
            name="chevron-up"
            aria-hidden="true"
            className="crosstab-view-sort-arrows"
          />
        </button>
        <button
          className="crosstab-viw-sort-desc-btn"
          onClick={() => handleArrowClick(SORT_DIRECTION.DESC)}
          disabled={direction === SORT_DIRECTION.DESC}
        >
          <FontAwesome
            name="chevron-down"
            aria-hidden="true"
            className="crosstab-view-sort-arrows"
          />
        </button>
      </span>
    );
  };

  const renderChoices = () => {
    return (
      <React.Fragment>
        {
          cellElements.map(cellElement => (
            <div key={cellElement.key}>
              <button key={cellElement.key} className={`ct-variable-item ${(ctIndex === cellIndex && variable === cellElement.key) && 'ct-variable-item_bold'}`} onClick={() => handleMenuClick(cellElement.key)} >
                {cellElement.label}
              </button>
            </div>
          ))
        }
        <div>
          <button className={`ct-variable-item ${(ctIndex === cellIndex && variable === 'none') && 'ct-variable-item_bold'}`} onClick={() => handleMenuClick('none')} >
            NONE
          </button>
        </div>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {renderUpDownButtons()}
      <div className="griditem-name-header">
        {sortDirectionText}
      </div>
      <div className="griditem-name-body">
        {renderChoices()}
      </div>
    </React.Fragment>
  );
};

GridSort.propTypes = {
  updateCrosstabSort: PropTypes.func,
  onSort: PropTypes.func,
  direction: PropTypes.string,
  variable: PropTypes.string,
  ctIndex: PropTypes.number,
  cellElements: PropTypes.arrayOf(PropTypes.shape({})),
  cellIndex: PropTypes.number,
  crosstabColumnSort: PropTypes.shape({}),
};

const mapStateToProps = state => {
  const { direction, variable, index } = state.crosstab.crosstabColumnSort;
  const { idKey } = state.crosstab.activeCrosstabTable;

  return {
    direction,
    variable,
    ctIndex: index,
    idKey,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCrosstabSort: bindActionCreators(updateCrosstabSort, dispatch),
    // updateCrosstabGrid: bindActionCreators(updateCrosstabGrid, dispatch),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(GridSort);
